let isScriptLoaded = false;
let scriptLoadPromise: Promise<void> | null = null;

export function getPayFieldsScriptUrl(environment?: string): string {
  const env = environment || "test";
  return env === "production"
    ? "https://api.payrix.com/payFieldsScript?spa=1"
    : "https://test-api.payrix.com/payFieldsScript?spa=1";
}

export async function loadPayFieldsScript(scriptUrl?: string): Promise<void> {
  if (isScriptLoaded && window.PayFields) {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById("payfields-script");
    if (existingScript && window.PayFields) {
      isScriptLoaded = true;
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = scriptUrl || getPayFieldsScriptUrl();
    script.id = "payfields-script";
    script.async = true;

    script.onload = () => {
      isScriptLoaded = true;
      resolve();
    };

    script.onerror = () => {
      scriptLoadPromise = null; // Reset promise to allow retry
      const error = new Error(
        "Failed to load PayFields script from " + script.src,
      );
      reject(error);
    };

    document.body.appendChild(script);
  });

  return scriptLoadPromise;
}
